import { useEffect } from 'react'
import { connect } from 'react-redux'
import { partnerHostLive, partnerHostStaging } from '../../../../../constants'

const Host = window.location.hostname
const pathPrefix =
  Host === partnerHostLive || Host === partnerHostStaging ? '/' : '/partner/'

const SERVICE_QUALITY_DOC_SHORT_PATH = `${pathPrefix}documents/service-quality-earning-adjustments`

const getServiceQualityDocPath = partnerToken =>
  `${pathPrefix}driver/app/${partnerToken}/documents/service-quality-earning-adjustments/account`

export const resolvePostLoginUrl = (oldUrl, partnerToken) =>
  oldUrl === SERVICE_QUALITY_DOC_SHORT_PATH
    ? getServiceQualityDocPath(partnerToken)
    : oldUrl

const PartnerDocumentRedirect = ({ history, isLoggedIn, partnerToken }) => {
  useEffect(() => {
    if (isLoggedIn && partnerToken) {
      history.replace(getServiceQualityDocPath(partnerToken))
    } else {
      history.replace({
        pathname: `${pathPrefix}auth/login`,
        state: { oldUrl: SERVICE_QUALITY_DOC_SHORT_PATH },
      })
    }
  }, [history, isLoggedIn, partnerToken])

  return null
}

const mapStateToProps = ({ auth }) => ({
  isLoggedIn: auth.isLoggedIn,
  partnerToken: auth.partnerToken,
})

export default connect(mapStateToProps)(PartnerDocumentRedirect)
